import { createSlice } from '@reduxjs/toolkit';

const marketingResourcesSlice = createSlice({
  name: 'marketingResources',
  initialState: {
    fetching: false,
  },
  reducers: {
    setFetchingFlag(state, { payload }) {
      state.fetching = payload;
    },
  },
});

export const { setFetchingFlag } = marketingResourcesSlice.actions;
export default marketingResourcesSlice.reducer;
